// 外見動画の種別（デザイン UPLOAD_ZONES と同じ並び。サーバー OPS_ASSET_KINDS と同期）
// hideWhenEmpty: 一覧（AppearanceCard）では登録済みの時だけ表示する
export const VIDEO_SLOTS = [
    { key: 'idle', label: 'idle 動画（待機状態）', short: 'idle', jp: '待機', required: true, group: 'motion' },
    { key: 'talk', label: 'talk 動画（発話中）', short: 'talk', jp: '発話', required: true, group: 'motion' },
    { key: 'nod', label: 'nod 動画（うなずき）', short: 'nod', jp: 'うなずき', required: false, group: 'motion' },
    { key: 'think', label: 'think 動画（思考中）', short: 'think', jp: '思考中', required: false, group: 'motion' },
    { key: 'think2', label: 'think2 動画（共感〜最終返答の間）', short: 'think2', jp: '共感〜最終返答の間', required: false, group: 'motion', hideWhenEmpty: true },
    { key: 'idle_mini', label: 'ウィジェット表示動画', short: 'mini', jp: '', required: false, group: 'widget' },
];

// Gemini-TTS はスタイル指示を受け付ける
export const VOICE_KIND_GEMINI = 2;

// 他テナント専用のボイスは選択肢に並べるが選べない（フラグが無いものは選べる扱い）
export const VOICE_UNAVAILABLE_SUFFIX = '　※利用不可';

export const isVoiceSelectable = (voice) => !!voice && voice.is_selectable !== false;

export const voiceOptionLabel = (voice) => `(ID:${voice.id}) ${voice.name}${isVoiceSelectable(voice) ? '' : VOICE_UNAVAILABLE_SUFFIX}`;

const extOf = (name) => {
    const m = /\.([^.]+)$/.exec(name || '');
    return m ? m[1].toLowerCase() : '';
};

// 差し替えで現在のファイル名に上書きするか（サーバー ops_overwrite_target と同じ判定。拡張子違いは新しい名前で追加）
export const willOverwrite = (asset, entry) => !!(asset && asset.overwritable && entry && extOf(asset.file_name) && extOf(asset.file_name) === extOf(entry.name));

// 1リクエストの上限（nginx client_max_body_size と同値。multipart の区切り分の余裕を見る）
export const REQUEST_SIZE_LIMIT = 100 * 1024 * 1024 - 1024 * 1024;
